import chroma from 'chroma-js';

import { COLORS, DEFAULT_LABEL_COLORS } from '../../../../../../common/colors/colorConstants';
import { getKeywordSentiment } from '../../../../../utils/keywordSentiment/keywordSentimentUtils';

const POSITIVE_SENTIMENT_LABEL_COLOR = COLORS.GREEN.name || 'GREEN';
const NEGATIVE_SENTIMENT_LABEL_COLOR = COLORS.RED.name || 'RED';

/**
 * Gets the colour to use for a newly created label.
 */
export const getLabelColor = (name: string, locale: string): string => {
    const upperName = (name || '').toUpperCase();
    const matchedColorWord = DEFAULT_LABEL_COLORS.find(
        (labelColor) => labelColor.name && upperName.includes(labelColor.name),
    )?.name;

    if (matchedColorWord) return matchedColorWord;

    const sentiment = getKeywordSentiment(name, locale);

    if (sentiment === 'positive') return POSITIVE_SENTIMENT_LABEL_COLOR;
    if (sentiment === 'negative') return NEGATIVE_SENTIMENT_LABEL_COLOR;

    return chroma.random().hex();
};
